/**
 * EligibilityChecklistDemo — Civic Benefits use case.
 * Dynamic checklist for complex eligibility (e.g., SNAP, housing assistance).
 */
import React, { useState } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EligibilityChecklist from '../../components/useCases/EligibilityChecklist';

const SNAP_ITEMS = [
  { id: 'resident', label: 'Resident of this state/county', required: true },
  { id: 'income', label: 'Household income at or below 130% of federal poverty level', required: true },
  { id: 'assets', label: 'Assets (savings, property) below program limit', required: true },
  { id: 'citizen', label: 'U.S. citizen or qualified immigrant', required: true },
  { id: 'work', label: 'Employed or exempt (elderly, disabled, etc.)', required: false },
];

export default function EligibilityChecklistDemo({ onBack }) {
  const [value, setValue] = useState({});

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Check the criteria that apply to determine preliminary eligibility for benefits.
      </Typography>
      <Paper variant="outlined" sx={{ p: 2 }}>
        <EligibilityChecklist
          items={SNAP_ITEMS}
          value={value}
          onChange={(e) => setValue(e?.target?.value || e)}
          label="SNAP eligibility checklist"
        />
      </Paper>
    </Box>
  );
}
